// Input normalisation for the codes identity accepts (contract §12): 6-digit TOTP/SMS/email codes and XXXX-XXXX recovery codes.

export const normaliseOtp = (value: string): string => value.replace(/\D/g, "");

export const isOtp = (value: string): boolean => /^\d{6}$/.test(normaliseOtp(value));

// Crockford base32 upper case; the dash is optional as typed and always sent. Look-alikes map as identity maps them (O→0, I/L→1).
export const normaliseRecoveryCode = (value: string): string => {
	const compact = value
		.toUpperCase()
		.replace(/[^0-9A-Z]/g, "")
		.replace(/O/g, "0")
		.replace(/[IL]/g, "1");
	return compact.length === 8 ? `${compact.slice(0, 4)}-${compact.slice(4)}` : value.trim().toUpperCase();
};

export const isRecoveryCode = (value: string): boolean => /^[0-9A-HJKMNP-TV-Z]{4}-[0-9A-HJKMNP-TV-Z]{4}$/.test(normaliseRecoveryCode(value));
